import React from 'react';

import styles from './UsersTooltip.module.scss';

interface IAssignedUsersTooltipProps {
	users: {
		firstName: string;
		lastName: string;
	}[];
	headerText?: string;
}

const UsersTooltip = ({
	users,
	headerText,
}: IAssignedUsersTooltipProps) => {
	return (
		<div className={styles.tooltipContainer}>
			{headerText
				&& <div className={styles.header}>
					{headerText}
				</div>
			}
			<div className={styles.usersList}>
				{users?.map(user => {
					return (
						<div
							key={user.firstName}
							className={styles.user}
						>
							{`${user.firstName} ${user.lastName}`}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default UsersTooltip;
